<nz-layout class="app-layout">
  <router-outlet></router-outlet>
</nz-layout>
